module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-4.2a167dbe.png";